<app-chatbot></app-chatbot>
<app-chatbot-modal *ngIf="readLocalStorageValue('modal')"></app-chatbot-modal>
<router-outlet (activate)="GATagPageView()"></router-outlet>
